var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState } from 'react';
import { AppSideNavigationMenuSub, AppSideNavigationSubMenuTitle, AppSideNavigationSubMenuItem, MenuWrapper, ResAppSideNavigationMenuSub, } from './styles';
import { matchPath } from 'react-router';
import { useLocation, useNavigate } from 'react-router-dom';
import AppBuilderMenu from './navigation';
import findSelectedMenu from '../../utils/findSelectedMenu/findSelectedMenu';
import { PermissionsWrapper } from '@project/components/PermissionsWrapper';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
function isMenuActive(activationPathMatch, pathname) {
    if (!activationPathMatch)
        return false;
    var paths = Array.isArray(activationPathMatch)
        ? activationPathMatch
        : [activationPathMatch];
    return paths.some(function (path) {
        return matchPath({
            path: path,
            end: false,
        }, pathname);
    });
}
var AppBuilderInnerSideBar = function (_a) {
    var _b;
    var appId = _a.appId, orgId = _a.orgId;
    var pathname = useLocation().pathname;
    var navigate = useNavigate();
    var _c = useState(true), show = _c[0], setShow = _c[1];
    // ======================find selected menu item ========================
    var AppBuilderMenuItems = AppBuilderMenu(appId, orgId).filter(function (menu) { return menu.id !== 3; });
    var selectedMenu = findSelectedMenu(AppBuilderMenuItems, pathname);
    // ======================!find selected menu item ========================
    return (selectedMenu === null || selectedMenu === void 0 ? void 0 : selectedMenu.children) ? (_jsxs(MenuWrapper, __assign({ onMouseOut: function () {
            setShow(true);
        } }, { children: [_jsx(ResAppSideNavigationMenuSub, __assign({ show: show, onMouseOver: function () {
                    setShow(false);
                } }, { children: show && _jsx(FontAwesomeIcon, { size: "lg", icon: faChevronRight }) })), _jsx(AppSideNavigationMenuSub, __assign({ onMouseOver: function () {
                    setShow(false);
                }, onMouseOut: function () {
                    setShow(true);
                } }, { children: (_b = selectedMenu === null || selectedMenu === void 0 ? void 0 : selectedMenu.children) === null || _b === void 0 ? void 0 : _b.map(function (child) { return (_jsxs(Fragment, { children: [_jsx(AppSideNavigationSubMenuTitle, { children: child.title }), child.data.map(function (item) { return (_jsx(PermissionsWrapper, __assign({ hideOnDisable: true, target: item.target || "app:".concat(appId), action: "read" }, { children: _jsxs(AppSideNavigationSubMenuItem, __assign({ onClick: function () {
                                    navigate(item.slug);
                                }, selected: isMenuActive(item.activationPathMatch, pathname) }, { children: [item.icon, item.label] }), item.slug) }), item.slug)); })] }, child.title)); }) }))] }))) : null;
};
export default AppBuilderInnerSideBar;
